export const MAPS_API_KEY = "AIzaSyDXA2Hl0LLmYdaZqD7K-w5l4_NU97_0n-U";